import { useLocation, Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { LOGO_URL } from "../lib/api";
import { LogIn, ShieldCheck } from "lucide-react";

export default function AdminLogin() {
  const { user, loading, login } = useAuth();
  const location = useLocation();
  const error = location.state?.error;

  if (loading) {
    return (
      <div className="min-h-screen bg-aawta-jet flex items-center justify-center">
        <div className="w-10 h-10 border-2 border-aawta-pink border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (user) return <Navigate to="/admin" replace />;

  return (
    <div className="min-h-screen bg-aawta-jet flex items-center justify-center px-6">
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-32 -left-32 w-[500px] h-[500px] rounded-full bg-aawta-blue/20 blur-3xl" />
        <div className="absolute -bottom-32 -right-32 w-[500px] h-[500px] rounded-full bg-aawta-pink/15 blur-3xl" />
      </div>
      <div className="relative glass-panel max-w-md w-full p-10 text-center">
        <img src={LOGO_URL} alt="AAWTA" className="h-16 w-16 object-contain bg-white/95 rounded-full p-1.5 mx-auto mb-6" />
        <p className="text-overline text-aawta-pink mb-3">AAWTA · BACKOFFICE COMMAND CENTER</p>
        <h1 className="font-display text-3xl text-white mb-3">Power to Drive Change<br/>Gala Operations</h1>
        <p className="text-white/60 text-sm leading-relaxed mb-8">
          Authorized AAWTA staff and event volunteers only. Sign in with your Google
          account; the Super Admin will assign your role.
        </p>

        {error && (
          <div data-testid="login-error" className="mb-6 border border-red-500/40 bg-red-500/10 text-red-200 text-sm p-3 text-left">
            {error}
          </div>
        )}

        <button
          data-testid="google-login-btn"
          onClick={login}
          className="btn-pink w-full justify-center"
        >
          <LogIn size={16} /> SIGN IN WITH GOOGLE
        </button>

        <p className="mt-6 text-overline text-white/40 flex items-center justify-center gap-2">
          <ShieldCheck size={12} /> SECURED BY EMERGENT AUTH
        </p>
      </div>
    </div>
  );
}
